
  import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator'

  @Component({
    components: {
    }
  })
  export default class General extends Vue  {
    $refs!: {
      form: any;
    }

    search1 = ''
    search2 = ''

    percentOwnership: any = [
      { text: '0', value: 0 },
      { text: '25', value: 25 },
      { text: '50', value: 50 },
      { text: '75', value: 75 },
      { text: '100', value: 100 },
    ]

    sdFo: any = [
      { text: 'SD', value: 'SD' },
      { text: 'FO', value: 'FO' },
      { text: 'Any', value: 'Any' },
    ]

    btDistricts: any = [
      '',
      'Bouquet Canyon',
      'Castaic',
      'Eastside',
      'Castaic',
      'Lyons/McBean Pkwy',
      'Magic Mountain',
      'Valencia',
      'Via Princessa'
    ]

    lmdZones: any = [
      '',
      '1 - Golden Valley Centex',
      '2 - Edwards Cinema',
      '3 - Sierra Heights',
      '4 - Via Princessa / Sierra Highway',
      '5 - Sunset Hills',
      '6 - Canyon Crest',
      '7 - Creekside',
      '8 - Ackerman Avenue',
      '15 - River Village',
      '16 - VIC',
      '17 - Bouquet / Railroad Ave',
      '18 - Town Center / Tourney',
      '19 - Bridgeport / Bouquet',
      '20 - Golden Valley Ranch Commercial',
      '21 - Golden Valley Ranch Residential',
      '22 - HMNMH',
      '23 - Montecito',
      '24 - Canyon Gate',
      '25 - Valle Di Oro',
      '26 - Centre Pointe Commercial',
      '27 - Circle J',
      '28 - Newhall',
      '29 - Villa Metro',
      '30 - Penlon',
      '31 - Five Knolls',
      '32 - Vista Canyon Ranch',
      '2008 - 1 - Major Thoroughfare Medians (Areawide Beautification)',
      'METRO 2 - SC Metro/Soledad Metro & JH Metro',
      'METRO 3 - Via Princessa (Zone 4)',
      'METRO 4 - TMF',
      'METRO5 - McBean Transfer Station (Zone 18)',
      'T-1 ADV - T-1 Ad Valorem',
      'T1 - Faircliff',
      'T1 B - Major Thoroughfare Medians (Plum Cyn/Skyline)',
      'T2 - Old Orchard',
      'T2 A - Skyline Ranch',
      'T3 - Valencia Hills',
      'T4 - Valencia Meadows',
      'T5 - Valencia Glen',
      'T6 - Valencia South Valley',
      'T7 - Valencia Central & North Valley',
      'T8 - Valencia Summit',
      'T17 - Rainbow Glen',
      'T20 - El Dorado Village',
      'T23 - Mountain View',
      'T23A - Mountain View Condos (Seco Canyon)',
      'T23B - Seco Villas',
      'T29 - American Beauty',
      'T31 - Shangri-La',
      'T33 - Canyon Park',
      'T44 - Bouquet Canyon',
      'T46 - Northbridge',
      'T47 - Northpark',
      'T48 - Shadow Hills',
      'T51 - Valencia High School',
      'T52 - Stonecrest (Lower/Mtnvw East)',
      'T62 - Canyon Heights',
      'T65 - Fair Oaks Ranch (Phase I)',
      'T65A - The Ranch at Fair Oaks (Phase II & III)',
      'T67 - Miramontes',
      'T68 - West Creek',
      'T69 - West Hills',
      'T71 - Haskell Canyon Ranch',
      'T77 - WEST CREEK PARK',
    ]

    maintainedBy: any = [
      { text: 'City', value: 'City' },
      { text: 'State', value: 'State' },
      { text: 'LA County', value: 'LA County' },
    ]

    valid = false
    lat = 34.4127176
    lng = -118.5533852

    bridgeNameRules: any = [
      ( v: any ) => !!v || 'Name is required',
    ]

    ratingRules: any = [
      ( v: any ) => ( !v || (v && v.length <= 10)) || 'Rating must be less than 10 characters',
    ]

    editedItem: any = {
      cityId: null,
      countyId: null,
      stateId: null,
      ownershipCity: null,
      ownershipCounty: null,
      ownershipState: null,
      ownershipRailroad: null,
      structureType: null,
      sdFo: null,
      yearBuilt: null,
      maintainedBy: null,
      paseo: null,
      roadway: null,
      nhs: null,
      inspectionPrecaution: null,
      id: -1,
      lat: 34.4127176,
      lng: -118.5533852,
      btDistrict: null,
      lmdZone: null,
      annexationDate: null,
    }

    @Prop() item!: any
    @PropSync('dialog', { type: Boolean }) compDialog!: boolean

    public updateMarker(event: any): void {
      this.editedItem.lat = event.latLng.lat()
      this.editedItem.lng = event.latLng.lng()
    }


    public save(): void {
      //emit
      if(this.$refs.form.validate()) {
        this.$emit('save', this.editedItem)
        this.compDialog = false //sync emit
      }

    }

    public setMarker(event: any): void {
      this.editedItem.lat = event.latLng.lat()
      this.editedItem.lng = event.latLng.lng()
    }


    @Watch('dialog')
    setItems(val: any) {
      if(val) {
        this.lat = this.item.lat
        this.lng = this.item.lng
        this.editedItem = Object.assign({}, this.item)
      }
      
    }

  }

